
import React from "react"; 
import { Loading, ActionBar, BoxArea } from "../component/BaseComponent";
import MenuComp, { PageTitle, IconList } from "../component/menucomp";
import Pagination from "../component/Paginator";
import { HttpsRequest, GetAuth, Alerts} from '../component/Utils';
import { APIRoute, RespStatus } from "../component/texts";
import { FaExpand } from "react-icons/fa";

// import { FormGroup } from '../component/form';
import {Modal, Button} from 'react-bootstrap'; 
// import {BASE} from '../component/http';


type PackageType = {    
    isbusy: boolean;    
    body: Record<string, string|number>[];
    pager: PagerType;
    data: Record<string, any>;    
    detail: Record<string, number|string|Record<string, number|string>>;    
    launch_modal: boolean;
}

type reporttype = {
    name:string;
    value:number|string;
}

const ReportComp = ({name, value}: reporttype) => {
    return (
        <tr> <td style={{textTransform: 'capitalize'}}>{name.replace('_', ' ')} </td> <th> {value} </th> </tr>
    )

}



export default class ShipmentReportUI extends React.Component<IProps, PackageType> {

    constructor(props: IProps){

        super(props); 

        this.state = {
            isbusy: false,  
            pager: {
                next_page: 0,
                page: 1,
                pages: [],
                prev_page: 0,
                total: 0,
                rows: 10
            },
            body: [],
             
            data: {},
              
            launch_modal: false,

            detail: {}
        }

    }

    render (){
        
        let sidecls = "col-sm-12";
 
        const _status: Record<string, string> = {
            'Pending': 'warning', 'Delivered': 'success', 'Cancelled': 'danger',
            'Rescheduled': 'info', 'Shipped': 'info', 'Enroute': 'warning', 'Others': 'warning'
        }

        return (
            <div>
                <MenuComp />                 
                <br />
                <ActionBar
                    classname={sidecls}
                    placeholder={"search"}
                    search={false}
                    btntitle={"Advance Filters"}
                    btnfunc={(e) => { e.preventDefault();}}
                    btnicon={IconList['package_add'] as JSX.Element}
                />
                <br />
                 
                <div className="container-fluid">
                    <div className="row posrel">

                        <BoxArea classname={sidecls + ' posrel'} >

                            <PageTitle title={'Waybill Reports'} />

                            <div className="table-responsive posrel">
                                <table className="table table-condensed table-striped table-hover">
                                    <thead>
                                        <tr>
                                            <td width='10%'> Date </td>
                                            <td width='30%'> Item Name  </td>
                                            <td> Type </td>
                                            <td> Amount </td>
                                            <td> Receiver </td> 
                                            <td> State </td>
                                            <td> Delivered By </td>
                                            <td> Last Updated </td>
                                            <td> Status </td> 
                                        </tr>
                                    </thead>
                                    <tbody> 
                                        {
                                            this.state.body.length === 0 ? <tr> <td colSpan={9} className="center"> <i> no data found...</i></td> </tr> : (
                                                this.state.body.map((item, idx) => (
                                                    <tr key={`rw${idx}`}>
                                                        <td> {item.date} </td>
                                                        <td> 
                                                            <a href={'#'} 
                                                                onClick={(event)=>{
                                                                    event.preventDefault(); 
                                                                    this.waybill_log_display(item  as Record<string, string|number>)
                                                                }}> <b>  {item.item_name}  </b> </a> 

                                                        </td>

                                                        <td> {item.payment_type } </td>
                                                        <td> {item.price } </td>
                                                        <td> {item.receiver} </td>
                                                        <td> {item.state } </td>
                                                        <td> {item.delivered_by } </td>
                                                        <td> {item.last_time } </td>
                                                        <td>  
                                                            <span className={`text-white badge bg-${_status[item.status]}`}> { item.status } </span>  
                                                        </td>                                                        
                                                        <td className='right'> 
                                                            <button title='Click to expand' 
                                                                className="btn btn-light btn-sm" 
                                                                onClick={ ()=>this.waybill_log_display(item as Record<string, string|number>)}>
                                                                <FaExpand size={15}/>
                                                            </button>
                                                       </td>  
                                                    </tr>
                                                ))
                                            )
                                        }
                                    </tbody>
                                </table>

                                <Pagination {...this.state.pager} navigate={this.refresh_page} />
                            </div>
                            <div>
                                {this.state.isbusy && <Loading />}
                            </div>
                           
                        </BoxArea>

                        <Modal show={this.state.launch_modal} size='lg' onHide={this.hide_modal}>
                            <Modal.Header closeButton>
                              <Modal.Title> {`Waybill Details: ${this.state.detail.item_name }`} </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <div className='table-responsive'>
                                            <table className='table table-condensed table-striped'>   
                                                <tbody>
                                                    {
                                                        Object.entries(this.state.detail).length > 0? (
                                                            Object.entries(this.state.detail).map(
                                                                ([key, value], idx) => {
                                                                
                                                                    if (key !== 'logdata' && key !== 'id'){                                                                
                                                                        return (
                                                                            <ReportComp key={`report-${idx}`} 
                                                                            name={key} value={value as string} />
                                                                        )
                                                                    }
                                                                }
                                                            )   
                                                        ) : null                                      
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className=''>     
                                            <h4 className='mb-5 text-center'> Activity Logs </h4>
                                            <ul style={{listStyle: 'none', paddingLeft: '0px'}}>    
                                            {
                                                Object.entries(this.state.detail.logdata || {}).length > 0? (
                                                    Object.entries(this.state.detail.logdata).map(
                                                        (row: string|any, idx) => (
                                                            <li className='mb-3'
                                                                style={{borderLeft: 'dotted 1px', paddingLeft: '20px', fontSize: '1.1rem'}}>

                                                                <small style={{'fontSize': '12px'}}> { row[1].date} </small> 
                                                                <br/> <span style={{fontSize: '15px'}}> {row[1].status}  </span>
                                                                <br/> <p style={{fontWeight: 500, marginTop: '10px'}}> {row[1].notes}  </p>
                                                            </li>
                                                        )                                                      
                                                    )

                                                ) : <li> No Activity Logged yet  </li>
                                            }
                                            </ul>
                                        </div>

                                    </div>

                                </div>
                                

                            </Modal.Body>
                            <Modal.Footer>
                              <Button variant="secondary" onClick={this.hide_modal}>
                                Close
                              </Button>
                            </Modal.Footer>
                        </Modal>


                    </div>

                </div>
            </div>
        )
    }

    componentDidMount(): void {
        this.load_package_data();
    }
 
    refresh_page = (page: number, rows: string|undefined) => {       
        this.load_package_data({page: String(page), rows:rows || '10'}); 
    }
 
    load_package_data = (args?: Record<string, string>) => {
        HttpsRequest.get(
            APIRoute.waybill_report, 
            this.get_callback,  GetAuth(), 
            (args || {}), (r:RespArgs) => this.setState({isbusy: false})
        )
    }

    get_callback = (resp: RespArgs) => {
        
        if (resp.status === RespStatus.success){
            this.setState({
                body: resp.body.data, 
                isbusy: false,  
                pager: resp.body.pager
            })  

        } else {
            this.setState({                
                isbusy: false 
            })
            Alerts.show_error(resp.status_msg); 
        }
 
    }
 
    hide_modal = ()=>this.setState({launch_modal: !this.state.launch_modal})
    
    waybill_log_display = (item:Record<string, string|number>) => {

        // Alerts.show_info('show the package log information');
        this.setState({detail: item}, this.hide_modal)

        console.log(item)
    }
 

     

}   

